import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MdFolderOpen } from 'react-icons/md';
import BackButton from './BackButton';

export default function ViewEmptyState({
  title = 'No Records Available',
  description = 'There are no records to display at this time.',
  icon: Icon = MdFolderOpen,
  canViewList = false,
  backRoute = null,
  backLabel = 'Back',
  action = null,
  containerClassName = 'container-fluid py-4',
}) {
  const navigate = useNavigate();

  return (
    <div className={containerClassName}>
      {canViewList && backRoute && (
        <div className="d-flex align-items-center mb-3">
          <BackButton onClick={() => navigate(backRoute)} label={backLabel} />
        </div>
      )}

      <div
        className="p-5 hc-surface rounded-4 text-center d-flex flex-column align-items-center justify-content-center shadow-sm"
        style={{ minHeight: '340px' }}
      >
        <div
          className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
          style={{
            width: 72,
            height: 72,
            backgroundColor: 'rgba(var(--hc-accent-blue-rgb, 60, 159, 162), 0.1)',
            color: 'var(--hc-accent-teal, #3c9fa2)',
          }}
        >
          <Icon size={36} />
        </div>

        <h4 className="fw-bold mb-2 text-dark" style={{ fontSize: '1.25rem' }}>
          {title}
        </h4>

        <p className="text-muted mb-4" style={{ maxWidth: '460px', fontSize: '0.92rem' }}>
          {description}
        </p>

        {action && <div className="mt-1">{action}</div>}

        {!action && canViewList && backRoute && (
          <button
            type="button"
            className="btn btn-outline-primary px-4 py-2 rounded-pill fw-semibold"
            onClick={() => navigate(backRoute)}
          >
            {backLabel}
          </button>
        )}
      </div>
    </div>
  );
}
